<template>
  <div v-if="usps">
    <div class="space-y-4 bg-surface">
      <div v-for="usp in usps" class="flex items-start space-x-3">
        <CheckCircleIcon class="w-6" />
        <p class="text-gray-800 font-medium text-foreground">
          {{ $t(usp.text) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { CheckCircleIcon } from "@heroicons/vue/20/solid";
import { ref } from "vue";
import brandconfig from "@/brandconfig";

const usps = ref(brandconfig?.checkoutUsps);
</script>
